// Shared helpers for the LeadDetail redesign.
// Kept tiny on purpose — UI niceties only.

export function fmtMoney(n) {
  return "$" + (Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });
}

// "5m ago" / "3h ago" / "2d ago" / fallback to date string.
export function relativeTime(ts) {
  if (!ts) return "";
  const t = new Date(ts).getTime();
  if (!t) return String(ts);
  const diff = Math.max(0, Date.now() - t);
  const min = Math.floor(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return min + "m ago";
  const hr = Math.floor(min / 60);
  if (hr < 24) return hr + "h ago";
  const d = Math.floor(hr / 24);
  if (d < 30) return d + "d ago";
  return new Date(ts).toLocaleDateString();
}

export function daysSince(dateStr) {
  if (!dateStr) return null;
  const t = new Date(dateStr).getTime();
  if (!t) return null;
  return Math.max(0, Math.floor((Date.now() - t) / 86400000));
}

// Score band → label + color for the right-panel card.
export function scoreBand(score) {
  const s = Math.max(0, Math.min(100, Number(score) || 0));
  if (s >= 80) return { label: "Hot Lead",  color: "#1a7a4a", bg: "#e6f4ec", emoji: "🔥" };
  if (s >= 60) return { label: "Warm Lead", color: "#d97706", bg: "#fef3c7", emoji: "" };
  if (s >= 40) return { label: "Cool Lead", color: "#6b7280", bg: "#f3f4f6", emoji: "" };
  return         { label: "Cold Lead", color: "#dc2626", bg: "#fee2e2", emoji: "" };
}

// Render note body with @mentions converted to styled pills. Body is plain
// text; mentions is an array of {name, accountno} (or strings).
export function renderNoteBody(body, mentions) {
  if (!body) return null;
  const names = [];
  if (Array.isArray(mentions)) {
    for (let i = 0; i < mentions.length; i++) {
      const m = mentions[i];
      if (typeof m === "string") names.push(m);
      else if (m && m.name) names.push(m.name);
    }
  }
  // Build a regex that matches "@<name>" for any known mention.
  if (names.length === 0) return body;
  const escaped = names.map(function (n) { return n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }).join("|");
  const re = new RegExp("@(" + escaped + ")", "g");
  const parts = [];
  let last = 0;
  let m;
  let idx = 0;
  while ((m = re.exec(body)) !== null) {
    if (m.index > last) parts.push(body.substring(last, m.index));
    parts.push({ mention: m[1], key: idx++ });
    last = m.index + m[0].length;
  }
  if (last < body.length) parts.push(body.substring(last));
  return parts;
}

// Decode JSON safely.
export function safeJson(v, fallback) {
  if (v == null) return fallback;
  if (typeof v !== "string") return v;
  try { return JSON.parse(v); } catch (_) { return fallback; }
}

// Type → icon glyph (used by timeline rows).
export const ACTIVITY_TYPE_STYLES = {
  stage:   { color: "#1c5bde", bg: "#e8eefb", label: "Stage"   },
  system:  { color: "#6b7280", bg: "#f3f4f6", label: "System"  },
  note:    { color: "#d97706", bg: "#fef3c7", label: "Note"    },
  call:    { color: "#1a7a4a", bg: "#e6f4ec", label: "Call"    },
  email:   { color: "#0369a1", bg: "#e0f2fe", label: "Email"   },
  task:    { color: "#6b3fa0", bg: "#f0eafa", label: "Task"    },
  convert: { color: "#15803d", bg: "#dcfce7", label: "Convert" },
};
